import React from "react";
import { WEEKDAYS, gridMax, heatmapIntensity, heatmapTitle } from "../analyticsUtils";
import { useIsDark } from "./ui";

/** 7 × 24 appointment counts, row 0 = Sunday. Pure CSS grid, one hue by intensity. */
export default function Heatmap({ grid }: { grid: number[][] }) {
  const isDark = useIsDark();
  const max = gridMax(grid);
  const rgb = isDark ? "57, 135, 229" : "42, 120, 214";
  const hours = Array.from({ length: 24 }, (_, h) => h);
  return (
    <div className="overflow-x-auto">
      <div className="min-w-[640px]">
        <div className="grid gap-[2px]" style={{ gridTemplateColumns: "2.5rem repeat(24, minmax(0, 1fr))" }}>
          <div />
          {hours.map((h) => (
            <div key={h} className="text-[10px] text-center text-slate-400 dark:text-slate-500 tabular-nums">
              {h % 3 === 0 ? h : ""}
            </div>
          ))}
          {WEEKDAYS.map((day, wd) => (
            <React.Fragment key={day}>
              <div className="text-[11px] text-slate-500 dark:text-slate-400 flex items-center">{day}</div>
              {hours.map((h) => {
                const value = grid[wd]?.[h] ?? 0;
                const t = heatmapIntensity(value, max);
                const alpha = value > 0 ? 0.15 + t * 0.85 : 0;
                return (
                  <div
                    key={h}
                    title={heatmapTitle(wd, h, value)}
                    className="aspect-square rounded-[3px] bg-slate-100 dark:bg-slate-700/60"
                    style={value > 0 ? { backgroundColor: `rgba(${rgb}, ${alpha})` } : undefined}
                  />
                );
              })}
            </React.Fragment>
          ))}
        </div>
        <div className="flex items-center justify-end gap-2 mt-2 text-[10px] text-slate-400 dark:text-slate-500">
          <span>0</span>
          <div className="flex gap-[2px]">
            {[0.15, 0.4, 0.6, 0.8, 1].map((a) => (
              <span key={a} className="w-3 h-3 rounded-[3px]" style={{ backgroundColor: `rgba(${rgb}, ${a})` }} />
            ))}
          </div>
          <span>{max}</span>
        </div>
      </div>
    </div>
  );
}
